import { type ButtonProps, Button } from './Button';

export { type ButtonProps, Button };

export default Button;
